

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { StringMap } from '@angular/compiler/src/compiler_facade_interface';
import { Cart } from '@/dto/cart/cart';
import { Transaction } from '@/dto/transaction/transaction';
import { Pos } from '@/dto/pos/pos';

@Injectable({ providedIn: 'root' })
export class ExportService {
    constructor(private http: HttpClient) {
    }

    getExportCart(typeExport: StringMap, cartFilter: Cart, sortCol: string, sortDir: string): Observable<any> {
        let params = new HttpParams().append('sortCol', sortCol.toString()).append('sortDir', sortDir.toString())
        if (cartFilter) {
            Object.keys(cartFilter).forEach(item => {
                params = params.append(item.toString(), cartFilter[item]?.toString() || '')
            })
        }
        return this.http.get(environment.apiUrl + "/dashboard/cart/export/" + typeExport, { params: params, responseType: 'blob' }).pipe(data => data);
    }

    getExportPOS(typeExport: string, filter: Pos, sortCol: string, sortDir: string): Observable<any> {
        let params = new HttpParams().append('sortCol', sortCol.toString()).append('sortDir', sortDir.toString())
        if (filter) {
            Object.keys(filter).forEach(item => {
                params = params.append(item.toString(), filter[item]?.toString() || '')
            })
        }
        return this.http.get(environment.apiUrl + "/dashboard/pos/export/" + typeExport, { params: params, responseType: 'blob' }).pipe(data => data);
    }

    getExportTransaction(typeExport: string, cartFilter: Transaction, sortCol: string, sortDir: string): Observable<any> {
        let params = new HttpParams().append('sortCol', sortCol.toString()).append('sortDir', sortDir.toString())
        if (cartFilter) {
            Object.keys(cartFilter).forEach(item => {
                params = params.append(item.toString(), cartFilter[item]?.toString() || '')
            })
        }
        return this.http.get(environment.apiUrl + "/dashboard/transaction/export/" + typeExport, { params: params, responseType: 'blob' }).pipe(data => data);
    }

    getAcprVeilleCsv(): Observable<Blob> {
        return this.http.get(environment.apiUrl + "/dashboard/acpr/transactions_veille", { responseType: 'blob' });
    }
}
